export default __webpack_public_path__ + "static/media/misc-books1-1024w.bc22fb59.webp";